import { Component, type ReactNode, type ErrorInfo } from 'react';
const seen = new Set<string>();
export function reportClientError(kind: 'client_render' | 'client_error' | 'client_rejection', error: unknown) {
  const stack = error instanceof Error ? (error.stack || '').split('\n').filter(l=>/^\s*at /.test(l)).slice(0,15).join('\n').slice(0,4000) : '';
  const signature = kind + stack;
  if (seen.has(signature) || seen.size >= 5) return;
  seen.add(signature);
  void fetch('/api/client-error',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({message:kind,stack,path:location.pathname})}).catch(()=>{});
}
export default class ErrorBoundary extends Component<{children:ReactNode},{failed:boolean}> {
  state = {failed:false};
  reported = false;
  static getDerivedStateFromError() { return {failed:true}; }
  componentDidCatch(error: Error, _info: ErrorInfo) { if (!this.reported) { this.reported=true; reportClientError('client_render',error); } }
  render() { return this.state.failed ? <main className="error-fallback"><h1>Something went wrong</h1><p>Your saved entries are safe. Reload to try again.</p><button onClick={()=>location.reload()}>Reload</button></main> : this.props.children; }
}
